import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import React from "react";
import { ShadowContainer, Typography, RaiseColors, MenuItem, makeStyles, useTheme, Icon } from "componentLibrary";
import { Menu } from "client/componentLibrary";
import useWindowSize from "hooks/useWindowSize";
import classNames from "classnames";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var ResponsivePillToDropDown = function ResponsivePillToDropDown(_ref) {
  var _useWindowSize$innerW;
  var dataList = _ref.dataList;
  var theme = useTheme();
  var windowSize = (_useWindowSize$innerW = useWindowSize().innerWidth) !== null && _useWindowSize$innerW !== void 0 ? _useWindowSize$innerW : 0;
  if (windowSize <= _valuesInstanceProperty(theme.breakpoints).md) {
    return /*#__PURE__*/_jsx(ResponsiveDropDown, {
      dataList: dataList
    });
  }
  return /*#__PURE__*/_jsx(ResponsivePill, {
    dataList: dataList
  });
};
export default ResponsivePillToDropDown;
var pillStyles = makeStyles(function (theme) {
  return {
    cell: {
      marginRight: "10px"
    },
    lastCell: {},
    emptyStyleState: {},
    pillText: {
      borderRadius: "200px",
      padding: "8px 16px 8px 16px",
      alignItems: "center",
      cursor: "pointer",
      display: "inline-flex"
    }
  };
});
var ResponsivePill = function ResponsivePill(_ref2) {
  var dataList = _ref2.dataList;
  var classes = pillStyles();
  var mutuallyExclusive = function mutuallyExclusive(recallFunction) {
    return function () {
      _mapInstanceProperty(dataList).call(dataList, function (data) {
        data === null || data === void 0 || data.setToActive(function () {
          return false;
        });
        return null;
      });
      recallFunction(true);
    };
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: _mapInstanceProperty(dataList).call(dataList, function (item, index, arr) {
      var gridCellStyle = classes.emptyStyleState;
      var lastInRow = index === arr.length - 1;
      if (lastInRow) {
        gridCellStyle = classes.lastCell;
      } else {
        gridCellStyle = classes.cell;
      }
      var isSelected = item === null || item === void 0 ? void 0 : item.active;
      return /*#__PURE__*/_jsx(ShadowContainer, {
        className: classNames(gridCellStyle, classes.pillText),
        style: {
          border: isSelected ? "1px solid ".concat(RaiseColors.jllRed) : "1px solid ".concat(RaiseColors.jllNeutral300),
          backgroundColor: isSelected ? RaiseColors.jllNeutral300 : ""
        },
        onClick: item !== null && item !== void 0 && item.setToActive ? mutuallyExclusive(item === null || item === void 0 ? void 0 : item.setToActive) : function () {},
        children: /*#__PURE__*/_jsx(Typography, {
          color: isSelected ? RaiseColors.jllRed : RaiseColors.jllRed,
          weight: "regular",
          variant: "paragraph_small",
          onClick: item !== null && item !== void 0 && item.setToActive ? mutuallyExclusive(item === null || item === void 0 ? void 0 : item.setToActive) : function () {},
          children: item === null || item === void 0 ? void 0 : item.displayText
        })
      }, index);
    })
  });
};
var DropDownStyles = makeStyles(function (theme) {
  return {
    menu: {
      backgroundColor: RaiseColors.neutral100,
      boxShadow: "0px 8px 32px rgba(43, 2, 129, 0.16)",
      borderRadius: 16,
      maxHeight: "50%",
      maxWidth: "50%"
    },
    horizontalItemContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      cursor: "pointer"
    },
    content: {
      display: "flex",
      flexDirection: "column",
      width: "100%"
    },
    pillText: {
      borderRadius: "200px",
      padding: "8px 16px 8px 16px",
      alignItems: "center",
      cursor: "pointer",
      display: "inline-flex"
    }
  };
});
var ResponsiveDropDown = function ResponsiveDropDown(_ref3) {
  var dataList = _ref3.dataList;
  var classes = DropDownStyles();
  var currentActiveInDataList = _findInstanceProperty(dataList).call(dataList, function (obj) {
    return (obj === null || obj === void 0 ? void 0 : obj.active) === true;
  }) || null;
  var mutuallyExclusive = function mutuallyExclusive(recallFunction) {
    return function () {
      _mapInstanceProperty(dataList).call(dataList, function (data) {
        data === null || data === void 0 || data.setToActive(function () {
          return false;
        });
        return null;
      });
      recallFunction(true);
    };
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Menu, {
      className: classes.menu,
      renderToggle: function renderToggle(_ref4) {
        var handleOpenClick = _ref4.handleOpenClick,
          isOpen = _ref4.isOpen;
        return /*#__PURE__*/_jsxs(ShadowContainer, {
          className: classes.pillText,
          style: {
            border: "1px solid ".concat(RaiseColors.neutral300)
          },
          onClick: handleOpenClick,
          children: [/*#__PURE__*/_jsx(Typography, {
            weight: "regular",
            variant: "paragraph_small",
            children: currentActiveInDataList ? currentActiveInDataList === null || currentActiveInDataList === void 0 ? void 0 : currentActiveInDataList.displayText : null
          }), /*#__PURE__*/_jsx(Icon, {
            className: isOpen ? "fa-thin fa-chevron-up" : "fa-thin fa-chevron-down",
            fontSize: 12,
            color: RaiseColors.midnight,
            style: {
              marginLeft: "10px",
              "float": "right"
            }
          })]
        });
      },
      children: _mapInstanceProperty(dataList).call(dataList, function (data, index, arr) {
        return /*#__PURE__*/_jsx(MenuItem, {
          style: {
            paddingRight: "16px",
            paddingLeft: "16px"
          },
          onClick: mutuallyExclusive(data === null || data === void 0 ? void 0 : data.setToActive),
          children: /*#__PURE__*/_jsx("div", {
            className: classes.horizontalItemContainer,
            children: /*#__PURE__*/_jsx("div", {
              className: classes.content,
              children: /*#__PURE__*/_jsx(Typography, {
                weight: "semibold",
                color: RaiseColors.midnight,
                children: data === null || data === void 0 ? void 0 : data.displayText
              })
            })
          })
        }, index);
      })
    })
  });
};